import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram } from 'lucide-react';

const TikTokIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
  </svg>
);

export const SOCIALS = [
  { id: 'instagram', label: 'Instagram', href: 'https://www.instagram.com/mayaplustv', Icon: Instagram },
  { id: 'tiktok', label: 'TikTok', href: 'https://www.tiktok.com/@maya.plus', Icon: TikTokIcon },
  { id: 'facebook', label: 'Facebook', href: 'https://www.facebook.com/mayaplustv/', Icon: Facebook },
];

export function SocialLinks({ size = 24, className = '' }) {
  return (
    <div className={`flex items-center gap-6 ${className}`}>
      {SOCIALS.map(({ id, label, href, Icon }) => (
        <a key={id} href={href} target="_blank" rel="noopener noreferrer" title={label}
          data-testid={`social-${id}`} className="text-white hover:text-[#E9641A] transition-colors">
          <Icon size={size} />
        </a>
      ))}
    </div>
  );
}

export const FOOTER_LINKS = [
  { label: 'FAQ', to: '/faq' },
  { label: 'Nous contacter', href: 'mailto:contact@mayaplus.fr' },
  { label: "Conditions d'utilisation", to: '/cgu' },
  { label: 'Politique de confidentialité', to: '/confidentialite' },
  { label: 'Mentions légales', to: '/mentions-legales' },
  { label: 'Mon compte', to: '/account' },
];

export default function Footer() {
  const linkCls = 'text-sm text-white/50 hover:text-white/80 underline underline-offset-2 transition-colors';
  return (
    <footer className="w-screen" style={{ marginLeft: 'calc(-1 * (50vw - 50%))', width: '100vw', background: '#0a0312' }} data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-8 md:px-16 py-16">
        <SocialLinks className="mb-10" />
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-y-4 gap-x-6 mb-10">
          {FOOTER_LINKS.map(l => l.to ? (
            <Link key={l.label} to={l.to} className={linkCls} data-testid={`footer-link-${l.label.toLowerCase().replace(/[\s']/g, '-')}`}>{l.label}</Link>
          ) : (
            <a key={l.label} href={l.href} className={linkCls} data-testid={`footer-link-${l.label.toLowerCase().replace(/[\s']/g, '-')}`}>{l.label}</a>
          ))}
        </div>
        <p className="text-xs text-white/30 mt-8">&copy; 2020-2026 Maya+ · Maya+ France — www.mayaplus.fr</p>
      </div>
    </footer>
  );
}
